exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reset-oa-box .input_box {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.reset-oa-box .input_box .lable {\n  padding-right: 6px;\n  color: red;\n}\n.reset-oa-box .input_box .label-txt {\n  display: inline-block;\n  width: 80px;\n}\n.reset-oa-box .ref_input {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.reset-oa-box .pop-btn {\n  display: flex;\n  flex-direction: row-reverse;\n}\n.reset-oa-box .pop-btn .cancel-btn {\n  margin-left: 10px;\n}\n", ""]);

// exports
